<template>
  <chapter-template :episode="episode" :chapter="chapter" :story="story"/>
</template>

<script>
import ChapterTemplate from '@/components/ChapterTemplate.vue'
export default {

  name: 'StoryViewer',
  components: {
    ChapterTemplate
  },
  data () {
    return {
    }
  },
  computed: {
    episode () {
      return this.$attrs.episode
    },
    chapter () {
      return this.$attrs.chapter
    },
    story () {
      return this.$attrs.story
    }
  }
}
</script>

<style lang="css" scoped>
</style>
